import dayjs from 'dayjs';

export const FOLLOW_UP_TYPE_OPTIONS = [
  { value: 1, label: '电话' },
  { value: 2, label: '拜访' },
  { value: 3, label: '微信' },
  { value: 4, label: '邮件' },
  { value: 5, label: '其他' },
] as const;

export const FOLLOW_UP_RESULT_OPTIONS = [
  { value: 'INVALID', label: '无效' },
  { value: 'OBSERVE', label: '待观察' },
  { value: 'EFFECTIVE', label: '有效' },
  { value: 'HIGH_INTENT', label: '高意向' },
] as const;

export const FOLLOW_UP_GOAL_OPTIONS = [
  { value: 'FIRST_TOUCH', label: '首次触达' },
  { value: 'INVITATION', label: '邀约' },
  { value: 'REQUIREMENT_CONFIRM', label: '需求确认' },
  { value: 'SOLUTION_DISCUSSION', label: '方案沟通' },
  { value: 'QUOTE_ADVANCE', label: '报价推进' },
  { value: 'CONTRACT_ADVANCE', label: '合同推进' },
  { value: 'PAYMENT_ADVANCE', label: '回款推进' },
  { value: 'RELATION_MAINTAIN', label: '关系维护' },
] as const;

export const FOLLOW_UP_QUALITY_SCORE_OPTIONS = [
  { value: 1, label: '1 分' },
  { value: 2, label: '2 分' },
  { value: 3, label: '3 分' },
  { value: 4, label: '4 分' },
  { value: 5, label: '5 分' },
] as const;

export const resolveFollowUpTypeLabel = (value: unknown) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '-';
  return (
    FOLLOW_UP_TYPE_OPTIONS.find((item) => item.value === numeric)?.label || '-'
  );
};

export const resolveFollowUpResultLabel = (value: unknown) =>
  FOLLOW_UP_RESULT_OPTIONS.find(
    (item) => item.value === String(value || '').trim(),
  )?.label || '-';

export const resolveFollowUpGoalLabel = (value: unknown) =>
  FOLLOW_UP_GOAL_OPTIONS.find(
    (item) => item.value === String(value || '').trim(),
  )?.label || '-';

export type FollowUpDateFields = {
  followUpDate?: string;
  followUpTime?: string | null;
  createTime?: string;
};

// An explicit date with no time is a date-only record. Only legacy records fall back to audit time.
export const followUpDateValue = (record: FollowUpDateFields) =>
  record.followUpDate
    ? `${record.followUpDate}${record.followUpTime ? ` ${record.followUpTime}` : ''}`
    : record.createTime;

export const formatFollowUpDate = (record: FollowUpDateFields) => {
  if (record.followUpDate) return followUpDateValue(record)!;
  const legacy = record.createTime ? dayjs(record.createTime) : undefined;
  return legacy?.isValid() ? legacy.format('YYYY-MM-DD HH:mm') : '-';
};
